import { AuthFacade } from 'src/app/store/auth/facade/auth.facade';
import { IAppState } from 'src/app/store/state/app.state';
import { EntityLegalType } from './../../../models/entity';
import { InvestorStatus } from './../../../models/investor';
import { IRegistrationKiwiSaverEntityState } from './../../state/registration-kiwisaver.state';
import { Observable, combineLatest } from 'rxjs';
import { selectRegistrationKiwiSaverEntityId, selectRegistrationKiwiSaverEntityState, selectRegistrationKiwiSaverFailText, selectRegistrationKiwiSaverStatus } from './../selectors/registration-kiwisaver.selectors';
import { tap, map, filter } from 'rxjs/operators';
import * as RegistrationKiwiSaverActions from './../actions/registration-kiwisaver.actions';
import { IRegisterKiwiSaverUser } from './../../../models/registration/register';
import { IRegistrationKiwiSaverState } from './../reducers/index';
import { Injectable } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { AuthService } from "../../../services/http/auth.service";
import { toObservable } from "@angular/core/rxjs-interop";
import { UserRelationshipsApiModel } from "../../../models/userRelationships";
@Injectable()
export class RegistrationKiwiSaverFacade {

    public failtext$: Observable<string>;
    public kiwiSaverInvestorStatus$: Observable<InvestorStatus> = this.store.pipe(select(selectRegistrationKiwiSaverStatus));
    private kiwisaverEntity$: Observable<IRegistrationKiwiSaverEntityState> = this.store.pipe(select(selectRegistrationKiwiSaverEntityState));
    private isUserLoggedIn$: Observable<boolean> = this.authFacade.userLoggedIn$();
    public getKiwiSaverLegalEntityType$: Observable<EntityLegalType> = this.store.pipe(
        select(selectRegistrationKiwiSaverEntityState)).pipe(
            filter((kiwiSaverEntity: IRegistrationKiwiSaverEntityState) => {
                return !!kiwiSaverEntity?.legalEntityType;
            }),
            map((kiwiSaverEntity: IRegistrationKiwiSaverEntityState) => {
                return kiwiSaverEntity.legalEntityType;
            })
        );

    constructor(
        private store: Store<IAppState>,
        private authFacade: AuthFacade,
        private authService: AuthService) {
        this.failtext$ = store.pipe(
            select(selectRegistrationKiwiSaverFailText)
        );
    }

    registerKiwiSaver(user: Partial<IRegisterKiwiSaverUser>) {
        this.store.dispatch(new RegistrationKiwiSaverActions.RegisterKiwiSaver(user));
    }

    getKiwisaverEntity(): Observable<IRegistrationKiwiSaverEntityState> {
        return combineLatest([
            this.kiwisaverEntity$,
            this.isUserLoggedIn$
        ]).pipe(
            filter((values: [IRegistrationKiwiSaverEntityState, boolean]) => {
                const [kiwisaverentityState, isLoggedIn] = values;
                return isLoggedIn;
            }),
            map((values: [IRegistrationKiwiSaverEntityState, boolean]) => {
                const [kiwisaverentityState] = values;
                return kiwisaverentityState;
            }),
            tap((kiwisaverentityState: IRegistrationKiwiSaverEntityState) => {
                if (!kiwisaverentityState && !this.authFacade.isAdministratorOrAdvisor()) {
                    this.store.dispatch(new RegistrationKiwiSaverActions.RegistrationKiwiSaverGetStatus());
                }
            })
        );
    }
}
